import React from 'react'
import { NavLink } from 'react-router-dom'
import { Features } from '../../../models/features'
import { Authorities } from '../../../models/authorities'
import useModuleMenu from '../../../hooks/useModuleMenu'
import { modules } from '../../../../modules'
import { getText } from '../../TextLabels'
import { TRANSACTION_PAGE_PATH } from '../../../pages/Transactions/constants'
import { isPaymentManagementModuleEnabled } from '../../../pages/PaymentManagement/paymentManagementModuleUtils'

export const generateMenuItems = (userAuthorities, menuItems) => {
  return menuItems
    ?.filter(({ authority }) => {
      return userAuthorities.includes(authority)
    })
    .map(({ link, label, key }) => {
      return {
        key,
        value: <NavLink to={link}>{label}</NavLink>,
      }
    })
}

export const addNavigationEntry = (
  userAuthorities,
  menuData,
  currentRoute,
) => ({
  key: menuData?.menu?.key,
  icon: menuData?.menu?.icon,
  value: menuData?.menu?.value,
  ...(menuData?.menu?.route &&
    !menuData?.menuItems?.length && {
      route: menuData.menu.route,
      active: currentRoute(menuData.menu.route),
    }),
  items: generateMenuItems(userAuthorities, menuData?.menuItems),
})

export const legacyTransactionsMenuItem = currentRoute => {
  return {
    key: Authorities.TRANSACTIONS.toLowerCase(),
    icon: 'midasCashRegister',
    value: getText('menu.main.transactions'),
    route: TRANSACTION_PAGE_PATH,
    active: currentRoute(TRANSACTION_PAGE_PATH),
  }
}

export const getTransactionMenuItems = (
  userAuthorities,
  representativeId,
  currentRoute,
  router,
) => {
  const entries = []
  const enabled = isPaymentManagementModuleEnabled(representativeId)
  let loadFailed = false

  if (enabled) {
    const moduleMenu = useModuleMenu(
      modules.paymentManagementApp,
      userAuthorities,
      true,
    )

    if (moduleMenu) {
      entries.push(
        addNavigationEntry(userAuthorities, moduleMenu, route =>
          router.location.pathname?.startsWith(route),
        ),
      )
    } else {
      loadFailed = true
    }
  }

  if (
    !enabled ||
    loadFailed ||
    localStorage.getItem(Features.PAYMENT_MANAGEMENT) === 'true'
  ) {
    entries.push(legacyTransactionsMenuItem(currentRoute))
  }

  return entries
}
